import type { AxiosError, AxiosRequestConfig } from "axios";
import axios from "axios";
import { useEffect, useState } from "react";
import type { UseAxiosState } from "./useAxios.d";

export function useAxios<Data>(axiosParams: AxiosRequestConfig): UseAxiosState<Data> {
  const [data, setData] = useState(undefined);
  const [error, setError] = useState<AxiosError>(undefined);
  const [loading, setLoading] = useState(true);

  const fetchData = async (params: AxiosRequestConfig) => {
    try {
      const { data } = await axios.request<Data>(params);
      setData(data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(axiosParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, error, loading };
}
